import { PartnerOnboardingEntityRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useRemindOnboardingApplication() {
  const [remindingOnboardingApplication, setRemindingOnboardingApplication] = useState(false);

  async function remindOnboardingApplication(params: PartnerOnboardingEntityRequest) {
    try {
      setRemindingOnboardingApplication(true);
      const res = await api.remindPartnerOnboardingApplication(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setRemindingOnboardingApplication(false);
    }
  }

  return { remindingOnboardingApplication, remindOnboardingApplication };
}
